// src/pages/home/SideEffects.js

import React from 'react';


import { 
    MDBContainer, 
    MDBBtn, 
    MDBModal, 
    MDBCol, 
    MDBCard, 
    MDBCardBody, 
    MDBModalBody,
    MDBRow} from 'mdbreact';


const SideEffects = ({ isOpen, toggle }) => {

    return (
        <MDBContainer>
            <MDBModal 
                size="medium" 
                centered
                isOpen={isOpen} 
                toggle={toggle}
            >
            <MDBModalBody className="d-flex">
                <MDBCol >
                    <h3 className="h2-responsive product-name">
                    <strong>Note the timing of health events and side effects.</strong>
                    </h3>
                    <div className="my-4">
                    <MDBCard>
                        <MDBCardBody>
                        <p>
                        Understanding side effects is very challenging.  If you suspect, then document.  
                        Build a timeline information that can help you and your provider ask better questions.
                        </p>
                        </MDBCardBody>
                    </MDBCard>     
                    </div>
                    <MDBRow className="justify-content-center mb-3">
                        <MDBBtn 
                            color="primary" 
                            className="ml-4" 
                            onClick={toggle} 
                        >
                        Close
                        </MDBBtn>
                    </MDBRow>
                    </MDBCol>
                </MDBModalBody>
            </MDBModal>
            </MDBContainer>
    );
}

export default SideEffects;